import React, { Component } from "react";
import PropTypes from "prop-types";
import "trix/dist/trix.css";
import mixpanel from "mixpanel-browser";
import { MixpanelProvider, MixpanelConsumer } from "react-mixpanel";
import { ReflectionListComponent } from "./ReflectionListComponent";
import { Upsells } from "./Upsells";
import { Pomodoro } from "./Pomodoro";
import { DailyAlphaWaves } from "./DailyAlphaWaves";
import SundayNav from './SundayNav'
import SundayTour from "./SundayTour";

export class Daily extends Component {
  render() {
    return (
      <MixpanelProvider mixpanel={mixpanel}>
        <main className="row">
          <section className="col trix-container">
            <ReflectionListComponent
              authenticityToken={this.props.authenticity_token}
              userId={this.props.user.id}
              reflectionType={"daily"}
            />
          </section>

          <section className="w-100 d-none layout-break"></section>
          <section className="col intro">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="intro_inner">
                    <SundayNav mode="daily" title="Daily Focus" />
                    <p className="small">
                      <strong>
                        Get into an instant flow state with the power of the
                        Pomodoro technique and Alpha Waves playing in the
                        background.
                      </strong>
                    </p>

                    <SundayTour mode='daily' label="Start Daily Tour" user={this.props.user}/>

                    <DailyAlphaWaves />

                    <MixpanelConsumer>
                      {(mixpanel) => (
                        <Pomodoro
                          githubURL="https://github.com/completejavascript/pomodoro-clock"
                          defaultBreakLength="5"
                          defaultSessionLength="15"
                          mixpanel={mixpanel}
                        />
                      )}
                    </MixpanelConsumer>

                    <div className="upsells">
                      <Upsells
                        trialTimestamp={
                          this.props.user.subscription.trial_end_at
                        }
                        user={this.props.user}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </MixpanelProvider>
    );
  }
}
